import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchFieldData: {},
  orderSummaryData: {}
};

export const orderSummarySlice = createSlice({
  name: 'searchFieldList',
  initialState,
  reducers: {
    setSearchFieldList: (state, searchFieldList) => {
      state.searchFieldData = searchFieldList;
    },
    setOrderSummaryDataList: (state, orderSummaryDataList) => {
      state.orderSummaryData = orderSummaryDataList;
    },
    purge: (state) => {
      state = initialState;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setSearchFieldList, setOrderSummaryDataList } = orderSummarySlice.actions;

export default orderSummarySlice.reducer;